var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"11"}},[_vm._v("e")]),_c('b-col',[_c('b-button-group',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.getFilter(1)}}},[_vm._v("Getir")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }